'use strict';

module.exports = require('./browser/algorithms.json');



//////////////////
// WEBPACK FOOTER
// ./~/browserify-sign/algos.js
// module id = 1045
// module chunks = 43